exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* CSS to enable table scroll with fixed header */\n\ntable.flex-table-container {\n  display: flex;\n  flex-flow: column;\n  /* height: 100%; */\n  width: 100%;\n  max-height: 174px;\n}\ntable.flex-table-container thead {\n  /* head takes the height it requires,\n  and it's not scaled when table is resized */\n  flex: 0 0 auto;\n  width: calc(100% - 1em);\n}\ntable.flex-table-container tbody {\n  /* body takes all the remaining available space */\n  flex: 1 1 auto;\n  display: block;\n  overflow-y: scroll;\n}\ntable.flex-table-container tbody tr {\n  width: 100%;\n}\ntable.flex-table-container thead,\ntable.flex-table-container tbody tr {\n  display: table;\n  table-layout: fixed;\n}\n/* decorations */\ntable.flex-table-container {\n  /* border: 1px solid #e7ecf1; */\n}\ntable.flex-table-container td, table.flex-table-container th {\n  padding: 0.3em;\n  /* border: 1px solid #e7ecf1; */\n  word-wrap: break-word;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/manage/ticket-log/table-scroll.css
// module id = 594
// module chunks = 0